import { Link } from 'src/components/atoms';
import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const StyledLink = styled(Link)`
  font-size: inherit;
  color: inherit;
  text-decoration: underline;
`;

export const InstallButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const SlackButtonContainer = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  width: 100%;
`;

export const SlackInstallContainer = styled.div<{ hasInstalled: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.hasInstalled ? 'end' : 'center')};
`;

export const UninstallSlackLink = styled.a`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  display: flex;
  align-items: center;
  padding-top: 10px;
  text-align: right;
  justify-content: end;
`;
